module.exports = __webpack_public_path__ + "img/tolyatti.1efd1dee.png";